//
// NetworkDataEvent.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import ClosetObject from "../../ClosetObject";
import "../../lib";
import "../../events/PortableEvent";
import "./URL";
import "./HttpVerb";
import "./NetworkDataResponseCode";
import "./AuthDelegate";
import "../../util/TriState";
import "./NetworkRequestContent";
import "../../events/EventDispatcher";

var NetworkDataEvent = createModule("commons::NetworkDataEvent", ["commons::PortableEvent"], ClosetObject, [
    {
        REQUEST: 10037,
        RESPONSE: 10038,
    },
    ,
    ,
    {
        directDownloadPath: 7,
        headers: [7],
        authDelegate: 1,
        httpVerb: 4,
        followRedirects: 2,
        expectedResponseCode: 4,
        guestConnection: 4,
        URL: 1,
        responseContent: 7,
        responseCode: 4,
    },
    {
        generateContentTypeHeader: [7],
        addContentInstance: [0,1],
        getContentCount: [4],
        getContentInstance: [1,4],
        createResponse: [1],
        sendResponse: [0,1],
        asEventDispatcher: [1],
        generateFullContentBody: [7],
        isResponseCodeSuccess: [2],
    },
    {
        _create: [4],
    },
    ,
]);
export default NetworkDataEvent;
